module.exports = __webpack_public_path__ + "img/scenario-teamfight.3aa9a2b.svg";